import React from 'react';
// import PropTypes from 'prop-types';

import Title from '../partials/Title';
import EventCards from '../partials/EventCards';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/season.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const SeasonPage = ({ page }) => {
    const { id = null, description = null } = page;

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{}</h2>
            <Title
                className={styles.title}
                seed={`title-${id}`}
                text={description}
                format="normal"
                borderPosition="bottom"
            />
            <div className={styles.inner}>
                <EventCards items={page.children} />
            </div>
        </div>
    );
};

SeasonPage.propTypes = propTypes;

export default SeasonPage;
